import { SearchQuery } from '@modules/feed/types';
import { EmptyWhereClause } from 'v2/core/services/queryBuilder/whereClause';

// to backfill source type mismatch
const transformSourceFilter = (
  whereClause: NonNullable<SearchQuery['whereClause']>,
): NonNullable<SearchQuery['whereClause']> => {
  if (whereClause.filter) {
    if (whereClause.filter.sourceFilter) {
      return {
        ...whereClause,
        filter: {
          ...whereClause.filter,
          sourceFilter: {
            sources: whereClause.filter.sourceFilter.sources.map((source) => {
              if (typeof source === 'string') {
                return {
                  name: source,
                };
              }
              return source;
            }),
          },
        },
      };
    }
    return whereClause;
  }
  if (whereClause.op) {
    return {
      ...whereClause,
      op: {
        ...whereClause.op,
        params:
          whereClause.op?.params.map((param) => transformSourceFilter(param)) ||
          [],
      },
    };
  }
  return whereClause;
};

export const deserializeWhereClause = (val: string) => {
  if (JSON.stringify(EmptyWhereClause) === val) {
    return EmptyWhereClause;
  }

  const whereClause = JSON.parse(val) as SearchQuery['whereClause'];

  if (!whereClause) {
    return null;
  }

  return transformSourceFilter(whereClause);
};
